import { render, staticRenderFns } from "./distributor_template.vue?vue&type=template&id=00ba19e6"
import script from "./distributor_template.vue?vue&type=script&lang=js"
export * from "./distributor_template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports